import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PurchaseButton } from './PurchaseButton';
import { getPrice } from '../utils/commerce';
const WATCH = ['top', 'purchase-panel', 'site-footer'];
export function MobileBuyBar() {
  const [hidden, setHidden] = useState<Record<string, boolean>>({
    top: true
  });
  const price = getPrice();
  useEffect(() => {
    const els = WATCH.map(id => document.getElementById(id)).filter((e): e is HTMLElement => Boolean(e));
    const io = new IntersectionObserver(entries => {
      setHidden(prev => {
        const next = {
          ...prev
        };
        entries.forEach(e => {
          next[e.target.id] = e.isIntersecting;
        });
        return next;
      });
    });
    els.forEach(e => io.observe(e));
    return () => io.disconnect();
  }, []);
  const visible = !Object.values(hidden).some(Boolean);
  return <AnimatePresence data-id="element-14" data-mp="13z1iofumiifl">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-charcoal px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 text-ivory shadow-[0_-8px_24px_rgba(0,0,0,0.25)] md:hidden" data-id="element-15" data-mp="140ultl612kiu">
          <div className="flex items-center gap-4" data-id="element-16" data-mp="5cbiaywxdk4i">
            <div className="min-w-0 flex-1" data-id="element-17" data-mp="3dtg45i0cobes">
              <p className="truncate text-[14px] font-semibold" data-id="element-18" data-mp="3ds4ytdr9avlk">Diesel Fault Atlas</p>
              {price ? <p className="text-[14px] text-mist" data-id="element-19" data-mp="39qt792oto0aq">
                  <span className="font-bold text-ivory" data-id="element-20" data-mp="3nksv87ebqxjr">{price.amount}</span> {price.currency}
                </p> : <p className="text-[13px] text-mist" data-id="element-21" data-mp="3ir7u46hfpngc">6 volumes + 5 bonuses</p>}
            </div>
            <PurchaseButton mode="auto" label="Buy" compact data-id="element-22" data-mp="2v1dittcrk6y7" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}